export const RTR_JS_VERSION = '2.1.0'
export const VM_JS_VERSION = '4.18.1'
export const BFF_PORT = 4000
export const ASSETS_PORT = 8080
export const ORIGIN_SUBDNS = '.instore.oakley.com'
